<div class="modal-body">
  <h5>Are you sure that you want to delete the following transaction(s)?</h5>
  <ul>
    <!-- TODO this view should probably be improved -->
    <li *ngFor="let transactionId of toDelete">
      {{ transactionId }}
    </li>
  </ul>
</div>
<div class="modal-footer">
  <button nf-button (click)="activeModal.dismiss()">Cancel</button>
  <button nf-button="delete" ngbAutoFocus (click)="delete()"></button>
</div>
